import { Translation } from "./Translation";

export const en: Translation = {
    Strings: {
        PropertyPaneDescription: "Configure the request parameters",
        PropertyPaneBasicGroupName: "Request Parameter Names",
        PropertyPaneVersionUrlParameter: "Document Version",
        PropertyPaneMgmtItemIdUrlParameter: "Management Item ID",

        StatusText_ActiveDoc: "This document is active!",
        StatusText_InactiveDoc: "This is not the active document!",

        MostCurrentVersionInfoText_Part1: "The requested document is in version ",
        MostCurrentVersionInfoText_Part2: ", but the most current version of it is ",

        OpenDocumentInBrowser: "Open Document in Browser",
        DownloadDocument: "Download",
        OpenFolderInBrowser: "Open Folder in Browser",

        OpenMostCurrentVersionInBrowser: "Open Most Current Version in Browser",
        DownloadMostCurrentVersion: "Download Most Current Version",
        OpenRequestedDocumentVersion: "Open Requested Version of Document",
        VersionDoesNotExist1: "Version ",
        VersionDoesNotExist2: ".0 does not exist!"
    }
}